export default __webpack_public_path__ + "static/media/ic_matic_16.03c3d5ff.svg";